import { MatDialogConfig } from '@angular/material/dialog';

/**
 * Shared size tiers for the protocol editor dialogs. Every editor-dialog
 * `MatDialog.open()` call site spreads one of these instead of hardcoding a
 * width, so the dialogs cannot drift apart over time. Each tier caps at 95vw /
 * 90vh so it shrinks gracefully on viewports narrower than its width.
 *
 * Stacking invariant (the tie-breaker when assigning a tier to a new dialog):
 * a dialog opened on top of another dialog must never be wider than the one
 * beneath it — equal widths are fine.
 */
type EditorDialogSize = Pick<MatDialogConfig, 'width' | 'maxWidth' | 'maxHeight'>;

/**
 * Primary editors — method type, pipeline, pipeline step, resource. Wider
 * than the shared 1000px editor-page column on purpose: dialogs have no page
 * margins to provide breathing room, so they keep the full 1200px surface.
 */
export const EDITOR_DIALOG_LARGE: EditorDialogSize = {
  width: '1200px',
  maxWidth: '95vw',
  maxHeight: '90vh',
};

/** Secondary editors — pipeline category, label config. */
export const EDITOR_DIALOG_MEDIUM: EditorDialogSize = {
  width: '900px',
  maxWidth: '95vw',
  maxHeight: '90vh',
};

/** Compact editors — case data field. */
export const EDITOR_DIALOG_SMALL: EditorDialogSize = {
  width: '720px',
  maxWidth: '95vw',
  maxHeight: '90vh',
};
